import DownArrow from './component'

export default DownArrow
